module.exports = __webpack_public_path__ + "img/youj.47b109ec.png";